import React, {useState, useEffect, useContext} from "react";
import {ButtonComponent} from "../elements";
import {TranslatorContext} from "../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import {Col, Form} from "react-bootstrap";
import {LabelFieldComponent} from "../fields";
import {setSetting} from "../../APIs/SettingRequests";


export default function SettingsTableComponent({thead, tbody, refreshPage}) {


    const [data, setData] = useState([]);
    const {t} = useContext(TranslatorContext);
    const [updateModal, setUpdateModal] = useState(false);

    const [currentSetting, setCurrentSetting] = useState();
    useEffect(() => {
        setData(tbody)
    }, [tbody]);

    const updateSettingAction = (key, value) => {
        setSetting(currentSetting.key, currentSetting.value).then((res) => {
            refreshPage();
        }).catch((error) => {
            console.log(error);
        });
    }
    return (
        <div className="mc-table-responsive">
            <table className="mc-table">
                <thead className="mc-table-head primary">
                <tr>
                    {thead.map((item, index) => (
                        <th key={index}>{item}</th>
                    ))}
                </tr>
                </thead>
                <tbody className="mc-table-body even">
                {data?.map((item, index) => {
                        if (item.key === "default_country") {
                            return;
                        }
                        return (
                            <tr key={index}>
                                <td title={item.key}>
                                    <div className="mc-table-profile">
                                        <p>{t(item.key)}</p>
                                    </div>
                                </td>
                                {
                                    item.key === "customer_image_mandatory" ?
                                        <td title={item.value}>{item.value === '1' ? t('True') : t('False')}</td>
                                        :
                                        <td title={item.value}>{item.value.length > 50 ? item.value.substring(0, 50) + '...' : item.value}</td>
                                }
                                {/* <td title={ item.value }>{ item.value }</td> */}

                                <td title={item.created}>{item.created_at}</td>
                                <td>
                                    <div className="mc-table-action">
                                        {/* <AnchorComponent to="/user-profile" title="View" className="material-icons view">{ "visibility" }</AnchorComponent> */}
                                        <ButtonComponent title="Update" className="material-icons edit" onClick={() => {

                                            if (item.key === "sim_contract_template") {
                                                window.location.href = '/sim-contract-template';
                                            } else {
                                                setUpdateModal(true, setCurrentSetting(item))
                                            }

                                        }}>{"update"}</ButtonComponent>
                                    </div>
                                </td>
                            </tr>
                        )
                    }
                )}
                </tbody>
            </table>
            <Modal show={updateModal} onHide={() => setUpdateModal(false, setCurrentSetting(""))}>
                <div className="mc-user-modal">
                    <h4>{t(currentSetting?.key)}</h4>
                    {
                        // currentSetting?.key === 'customer_image_mandatory' ?
                        //     <Col xl={6}><LabelFieldComponent label={t(currentSetting?.key)} fieldSize="w-100 h-md" option={[{id:'true',name:'True'},{id:'false',name:'False'}]} value={ currentSetting?.value === '1' ? true : false } onChange={(e)=> setCurrentSetting({key:currentSetting?.key,value:(e.target.value==='true')?true:false})}/></Col>
                        //     :
                        //     <Col xl={6}><LabelFieldComponent type="text" label={t(currentSetting?.key)}  fieldSize="w-100 h-md" value={ currentSetting?.value } onChange={(e)=> setCurrentSetting({key:currentSetting?.key,value:e.target.value})}/></Col>
                        
                        currentSetting?.key === 'customer_image_mandatory' ? (
                            <Col xl={6}>
                                <LabelFieldComponent
                                    label={t(currentSetting?.key)}
                                    fieldSize="w-100 h-md"
                                    option={[
                                        {id: 'true', name: t('True')},
                                        {id: 'false', name: t('False')}
                                    ]}
                                    value={currentSetting?.value === '1' ? true : false}
                                    onChange={(e) =>
                                        setCurrentSetting({
                                            key: currentSetting?.key,
                                            value: e.target.value === 'true' ? true : false
                                        })
                                    }
                                />
                            </Col>
                        ) : ['local_individual_sims_number', 'foreign_individual_sims_number'].includes(currentSetting?.key) ? (
                            <Col xl={6}>
                                <LabelFieldComponent
                                    type="number"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    min={0}
                                    step={1}
                                    label={t(currentSetting?.key)}
                                    fieldSize="w-100 h-md"
                                    value={currentSetting?.value ?? ''}
                                    onChange={(e) => {
                                        const digitsOnly = (e.target.value || '').replace(/\D/g, '');
                                        setCurrentSetting({key: currentSetting?.key, value: digitsOnly});
                                    }}
                                />
                            </Col>
                        ) : (
                            <Col xl={6}>
                                <LabelFieldComponent
                                    type="text"
                                    label={t(currentSetting?.key)}
                                    fieldSize="w-100 h-md"
                                    value={currentSetting?.value}
                                    onChange={(e) =>
                                        setCurrentSetting({key: currentSetting?.key, value: e.target.value})
                                    }
                                />
                            </Col>
                        )
                    }

                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary"
                                         onClick={() => setUpdateModal(false)}>{t('close_popup')}</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-success" onClick={() => {
                            updateSettingAction();
                            setUpdateModal(false)
                        }}>{t('save_changes')}</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>


        </div>
    )
}